<app-generic-modal bodyClasses="p-0" [onCloseFn]="onClose">
  <ng-template appModalHeader>
    <h2 class="m-0">
      {{ 'MANAGED_USERS.EDIT_USER' | translate }}
    </h2>
  </ng-template>

  <ng-template appModalBody>
    <ul class="nav nav-pills d-flex gap-4 px-4 border-bottom">
      <li class="nav-item cursor-pointer flex-grow-1 flex-basis-0" (click)="activeTab = 'information'">
        <span class="nav-link full-bottom-border-width px-0" [class.active]="informationTabActive">
          {{ 'PROFILE.PROFILE_INFORMATION' | translate }}
        </span>
      </li>
      <li class="nav-item cursor-pointer flex-grow-1 flex-basis-0" (click)="activeTab = 'permissions'">
        <span class="nav-link full-bottom-border-width px-0" [class.active]="!informationTabActive">
          {{ 'MANAGED_USERS.PERMISSIONS' | translate }}
        </span>
      </li>
    </ul>

    @if (activeTab === 'information') {
      <div class="d-flex align-items-center gap-3 mx-4 py-4 border-bottom">
        <img
          [src]="(user.profilePicture?.url ?? '/assets/images/user/user.png') | resizeImage: imageSizes.SIZE_120x120"
          class="sp-60 rounded-circle"
          draggable="false"
        />

        <div>
          <h4>{{ username }}</h4>
          <app-tag
            [bgClass]="user.isActive ? 'bg-success-600' : 'bg-danger'"
            [icon]="user.isActive ? 'ni-tick-circle' : 'ni-not-interested'"
            [translationKey]="user.isActive ? 'MANAGED_USERS.ACCOUNT_IS_ACTIVE' : 'MANAGED_USERS.ACCOUNT_IS_BLOCKED'"
          />
        </div>
      </div>

      <div class="p-4">
        <app-managed-user-profile [profileForm]="profileForm" />
      </div>
    } @else {
      <div class="p-4">
        <app-user-permissions
          [permissionsForm]="permissionsForm"
          [permissionOptions]="permissionOptions"
          data-testid="userPermissions"
        />
      </div>
    }
  </ng-template>

  <ng-template appModalFooter>
    <button
      type="submit"
      class="btn btn-primary btn-lg w-50 d-flex align-items-center justify-content-center h-100 no-outline"
      (click)="onSave()"
      data-testid="saveButton"
    >
      {{ 'INQUIRIES.PRICE_REQUESTS.ACTIONS.SAVE' | translate }}
    </button>
  </ng-template>
</app-generic-modal>
